/* Traduction FR des avis Judge.me - affichage uniquement, les avis d'origine ne sont pas modifies */
(function () {
  var MAP = {
    "this is the fourth mask i've bought, and the last 3 arrived with the box dented and broken. it's impossible to use it as a gift due to the poor presentation. they need to change the shipping service.": "C'est le quatrième masque que j'achète, et les 3 derniers sont arrivés avec la boîte cabossée et abîmée. Impossible de l'offrir en cadeau avec une présentation pareille. Ils devraient changer de service de livraison.",
    "very good quality, works perfectly.": "Très bonne qualité, fonctionne parfaitement.",
    "great product, i tried to order more but really bad communication from the company.": "Très bon produit, j'ai essayé d'en commander d'autres mais la communication avec l'entreprise est vraiment mauvaise.",
    "very good. the battery lasts for 2 uses.": "Très bien. La batterie tient 2 utilisations.",
    "i'm loving it! i can see a change in my skin. so far i haven't used the red led, but i'm much better off with the sagging skin!": "J'adore ! Je vois un changement sur ma peau. Je n'ai pas encore utilisé la LED rouge, mais je vais déjà beaucoup mieux au niveau du relâchement de la peau !",
    "the box arrived dented and the lid was broken into pieces, but the mask inside was fine. it's a shame because i bought it as a gift. fortunately, i had the box from another one i had bought.": "La boîte est arrivée cabossée et le couvercle en morceaux, mais le masque à l'intérieur était intact. Dommage, car je l'avais acheté pour l'offrir. Heureusement, j'avais gardé la boîte d'un autre que j'avais acheté.",
    "the mask arrived quickly; it's convenient that it's wireless, but it's unclear where the battery is and how long it will last. it's very lightweight. 7 colors. so far i like it; i'll write later about whether it has any effect.": "Le masque est arrivé rapidement ; c'est pratique qu'il soit sans fil, mais on ne sait pas où se trouve la batterie ni combien de temps elle tient. Il est très léger. 7 couleurs. Pour l'instant il me plaît ; je reviendrai dire s'il fait vraiment de l'effet.",
    "perfect packaging everything is working": "Emballage parfait, tout fonctionne.",
    "the product is great! delivery to moscow in less than two weeks.": "Le produit est super ! Livraison à Moscou en moins de deux semaines.",
    "very happy": "Très contente",
    "excellent product, thanks :)": "Excellent produit, merci :)",
    "i loved it": "J'ai adoré 💕",
    "the mask is light but quite far from the skin, so i don't think the effect is strong. there's also hardly any heat generation. waiting to see...": "Le masque est léger mais assez éloigné de la peau, donc je ne pense pas que l'effet soit très fort. Il ne chauffe presque pas non plus. J'attends de voir...",
    "i loved the product, i have already used it several times and i do notice changes. the shipping was fast.": "J'ai adoré le produit, je l'ai déjà utilisé plusieurs fois et je remarque des changements. La livraison a été rapide.",
    "i bought it for my mother, she really liked it.": "Je l'ai acheté pour ma mère, elle l'a beaucoup aimé."
  };

  function norm(s) {
    return (s || '')
      .replace(/[‘’]/g, "'")
      .replace(/[…]/g, '...')
      .replace(/[\u{1F300}-\u{1FAFF}☀-➿️]/gu, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  var KEYS = Object.keys(MAP);

  function lookup(txt) {
    var k = norm(txt);
    if (!k) return null;
    if (MAP[k]) return MAP[k];
    for (var i = 0; i < KEYS.length; i++) {
      var key = KEYS[i];
      if (key.length > 25 && (key.indexOf(k) === 0 || k.indexOf(key) === 0)) return MAP[key];
    }
    return null;
  }

  function apply() {
    var nodes = document.querySelectorAll('.jm-review-content__body, .jdgm-rev__body');
    for (var i = 0; i < nodes.length; i++) {
      var el = nodes[i];
      if (el.getAttribute('data-jm-fr')) continue;
      var fr = lookup(el.textContent);
      if (!fr) continue;
      var target = el.querySelector('.jdgm-review-content__body-content') || el;
      target.textContent = fr;
      el.setAttribute('data-jm-fr', '1');
      el.setAttribute('lang', 'fr');
    }
  }

  function start() {
    apply();
    try {
      new MutationObserver(function () { apply(); })
        .observe(document.documentElement, { childList: true, subtree: true });
    } catch (e) {}
    setInterval(apply, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
